export default "__VITE_ASSET__BkZT2lfC__"